import React from 'react'

export default function RetroGrid() {
    return (
        <div className="retro-grid no-print" aria-hidden="true">
            <div className="retro-grid-plane">
                <div className="retro-grid-lines" />
            </div>
            <div className="retro-grid-fade" />
        </div>
    )
}
